<template>
    <ui-scroll-reveal :offset="88" element-class="back-to-top">
        <div class="grid grid__base">
            <div class="grid--container">
                <div class="back-to-top--button-wrap">
                    <simple-btn class="back-to-top--button" :facets="['bubble', 'primary', 'medium']" @click="onButtonClick">
                        <ui-icon size="medium" symbol="back_to_top"/>
                    </simple-btn>
                </div>
            </div>
        </div>
    </ui-scroll-reveal>
</template>

<script>
    import UiScrollReveal from '@dreipol/vue-ui/src/components/scroll-reveal/scroll-reveal';
    import UiIcon from '@dreipol/vue-ui/src/components/icon/icon';
    import SimpleBtn from '../../components/buttons/simple-btn/simple-btn';

    export default {
        components: {
            SimpleBtn,
            UiIcon,
            UiScrollReveal,
        },
        methods: {
            onButtonClick() {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth',
                });
            },
        },
    };
</script>
